<template>
  <div class="template_home_box"> 
    <div class="temp_top_box "> 
      <div class="temp_val_box">
        <div class="temp_logo" @click="pageChange">
          <img src="@/assets/home/logo.png" alt="">
        </div> 
        <div class="temp_btn_box"> 
          <template v-if="userInfo.employeeName">
            <div class="user_box" @click="JumpChange()">
              <div class="img_ava" :style="{'background-image': 'url('+userInfo.studentImage+')'}">
                <!-- <img :src="userInfo.studentImage" alt=""> -->
              </div>
              <span class="s1">{{userInfo.employeeName}}</span>
            </div>
          </template>
          <template v-else>
            <div class="temp_item" @click="loginBoxChange('1')">登录</div> 
            <div class="temp_item register" @click="loginBoxChange('2')">注册</div> 
          </template>
        </div> 
      </div>
    </div> 
    <div class="temp_content_box"> 
      <div class="temp_content">
        <router-view /> 
      </div>
      
      <div class="temp_content_bj"></div>
    </div> 
    <div class="temp_bottom_box">
      <div class="temp_val_box">
        <div class="temp_bottom_left">
          <div class="temp_logo_footer">
            <img src="@/assets/home/logo_footer.png" alt="">
          </div> 
        </div>
        <div class="temp_bottom_rgiht">
          <div class="txt_box">
            <div class="txt">校址：广州市白云区沙太南路1023号-1063号</div>
            <div class="line"></div>
            <div class="txt">咨询电话：020-61649459</div>
          </div>
          <div class="txt_box">
            <div class="txt">京ICP备14049531号</div>
            <div class="line"></div>
            <div class="txt">经营许可证编号: 京 B2-20182184</div>
            <div class="line"></div>
            <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank">
              <div class="txt dis_ajc">
                <img class="filings" src="@/assets/home/filings.png" alt="">
                京公网安备 11010502035129号
              </div> 
            </a>
          </div>
        </div>
      </div>
    </div> 

    <!-- 登录、注册 弹窗 -->
    <LoginModalBox ref="loginBox" @loginChange="loginChange"></LoginModalBox>
  </div>
</template>
<script setup>
import { ref, reactive, onMounted, computed, watch } from "vue";
import { UserOutlined, LockOutlined, PlusOutlined } from "@ant-design/icons-vue"; 
import LoginModalBox from "@/views/home/login/index.vue"; 
import { useRouter } from "vue-router";  
import { useStore } from "vuex";  
const router = useRouter();
const store = useStore(); 

function pageChange() {
  router.push({ path: "/home" }); 
}

const loginBox = ref(null); 
function loginBoxChange(type) { 
  if (loginBox.value) {
    loginBox.value.loginChange(type); 
  } 
} 

const userInfo = computed(()=>{
  return store.getters["data/getUserInfo2"] || {}; 
})
// let userInfo = ref({})
// onMounted(()=>{
//   let userInfoData = JSON.parse(localStorage.getItem("userInfo"))
//   if (userInfoData) {
//     setTimeout(() => {
//       userInfo.value = userInfoData;
//     }, 200);
//   }
// })

// 跳转后台 
function JumpChange() {
  router.push({ path: "/myPage" }); 
}; 

function loginChange() {
  
}

</script>
<style lang="scss" scoped> 
@import "@/style/var.scss";
.template_home_box { 
  width: 100%; 
  min-height: 100vh;
  --temp_width: 1250px;
  display: flex;
  flex-direction: column;
} 
img {
  width: 100%;
  height: 100%;
}
.temp_val_box {
  width: var(--temp_width);
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.temp_top_box { 
  width: 100%; 
  height: 118px; 
  background: url("../assets/home/header.png") 50% no-repeat;
  background-size: cover;
  .temp_logo {
    width: 360px;
    height: 110px;
    cursor: pointer;
  }
  .temp_btn_box {
    display: flex;
    align-items: center;
    .temp_item {
      margin-left: 16px;
      width: 102px;
      height: 40px;
      background: #fff;
      border-radius: 4px;
      font-size: 16px;
      color: #096cb8;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .register {
      background: hsla(0, 0%, 100%, .1); 
      border: 1px solid #fff;
      color: #FFFFFF;
    }
  }
}

.temp_content_box {
  flex: 1;
  min-width: var(--temp_width); 
  position: relative;
  .temp_content {
    position: relative;
    z-index: 2;
  }
  .temp_content_bj {
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 386px;
    background: url("../assets/home/content.png") 50% no-repeat;
    background-size: 110% 386px;
  }
}

.temp_bottom_box {
  width: 100%;
  height: 90px;
  background: #454140;
  .temp_logo_footer {
    width: 215px;
    height: 60px;
  }
  .temp_bottom_rgiht {
    font-size: 14px; 
    color: #a19fa0; 
    .txt_box {
      margin: 8px 0;
      display: flex;
      align-items: center;
      .line {
        margin: 0 15px;
        width: 1px;
        height: 13px;
        background: #a19fa0;
      }
      .txt {
        color: #a19fa0; 
      }
      .filings {
        margin-right: 4px;
        width: 15px;
        height: 15px;
      }
    }
  }
}

.user_box {
  display: flex;
  align-items: center;
  cursor: pointer;
  .img_ava {
    // width: 60px;
    // height: 60px;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    // overflow: hidden;

    
    background-position: center center; /* 水平垂直居中 */
    background-repeat: no-repeat; /* 不重复背景图 */
    background-size: cover;
    img {
      width: 100%;
      height: auto;
    }
  }
  .s1 {
    padding-left: 10px;
    font-size: 20px;
    font-weight: 600;
    color: #454140;
  }
}

</style>
